import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { UserService } from '../../services/user.service';
import { ColDef, GridOptions, GridApi } from "ag-grid-community";

// Unique errors (order Note) per gateway with their occurrence, for the filters applied on Offramp Orders
@Component({
  selector: 'app-payout-error-report-dialog',
  templateUrl: './payout-error-report-dialog.component.html',
  styleUrls: ['./payout-error-report-dialog.component.css']
})
export class PayoutErrorReportDialogComponent implements OnInit {
  private gridApi: GridApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };
  isLoading: boolean = true;
  totalOccurrence: number = 0;

  constructor(
    public dialogRef: MatDialogRef<PayoutErrorReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifSer: NotificationsService,
    private userService: UserService
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.loadErrors();
  }

  initializeGrid() {
    this.columnDefs = [
      { headerName: 'Gateway', field: 'gateway', flex: 1, valueFormatter: (params) => params.value || '-' },
      { headerName: 'Error', field: 'error', flex: 4, tooltipField: 'error' },
      { headerName: 'Occurrence', field: 'occurrence', flex: 1, sort: 'desc', filter: 'agNumberColumnFilter' }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  loadErrors() {
    this.isLoading = true;
    this.userService.getPayoutOrderErrorReport(this.data.filter).subscribe(
      (rows: any) => {
        this.isLoading = false;
        this.rowData = rows || [];
        this.totalOccurrence = this.rowData.reduce((sum, row) => sum + row.occurrence, 0);
        if (this.gridApi) {
          this.gridApi.setRowData(this.rowData);
        }
      },
      (error) => {
        this.isLoading = false;
        this.rowData = [];
        this.notifSer.error("Error", (error.error && error.error.message) || "Failed to load error report. Please try again.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  // Exports the rows as currently filtered / sorted in the grid
  exportCsv() {
    if (this.gridApi) {
      const { fromDate, toDate } = this.data.filter;
      this.gridApi.exportDataAsCsv({ fileName: `payout-error-report-${fromDate}_${toDate}.csv` });
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/payout-orders/payout-error-report-dialog/payout-error-report-dialog.component.ts